import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {PaginationInstance} from 'ngx-pagination';
import {ToastrService} from 'ngx-toastr';
import {CepFormService} from 'src/app/api/module/erp/services/consultaCEP/cep-form-service.service';
import {tipoAcaoEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-acao-enum';
import {GeoLocalizacaoService} from 'src/app/api/module/erp/shared/geo-localizacao/geo-localizacao.service';
import {TabelaComponent} from '../tabela/tabela.component';

@Component({
  selector: 'app-endereco',
  templateUrl: './endereco.component.html',
  styleUrls: ['./endereco.component.scss'],
})
export class EnderecoComponent implements OnInit {
  private _ehSomenteLeitura: boolean = false;
  private _numeroObrigatorio: boolean = true;
  private _tipoEnderecoObrigatorio: boolean = true;

  @ViewChild(TabelaComponent) tabelaComponent!: TabelaComponent;

  @Input() estaAberto: boolean = false;
  @Input() mostrarCampoSelectEstadoCidade: boolean = true;
  @Input() mostrarColunaAcao: boolean = true;
  @Input() mostrarFormulario: boolean = true;
  @Input() mostrarTipoEndereco: boolean = false;
  @Input() ocultarBtnAcao: boolean = false;
  @Input() ocultarTabela: boolean = false;
  @Input() ocultarNumero: boolean = false;
  @Input() ocultarComplemento: boolean = false;
  @Input() set somenteLeitura(valor: boolean) {
    this.ehSomenteLeitura = valor;
  }
  @Input() set ehSomenteLeitura(valor: boolean) {
    this._ehSomenteLeitura = valor;
    this.aplicarEstadoSomenteLeitura();
  }
  @Input() set dadosEndereco(dados: any) {
    if (dados) {
      this.enderecoListaCompleta = dados;
      this.config.currentPage = 1;
      this.atualizarListaPaginada();
    }
  }
  @Input() set numeroObrigatorio(valor: boolean) {
    this._numeroObrigatorio = valor !== undefined ? valor : true;
    if (this.enderecoForm) {
      this.adicionarObrigatoriedadeNoFormulario();
    }
  }
  get numeroObrigatorio(): boolean {
    return this._numeroObrigatorio;
  }

  @Input() set tipoEnderecoObrigatorio(valor: boolean) {
    this._tipoEnderecoObrigatorio = valor !== undefined ? valor : false;
    if (this.enderecoForm) {
      this.adicionarObrigatoriedadeNoFormulario();
    }
  }
  get tipoEnderecoObrigatorio(): boolean {
    return this._tipoEnderecoObrigatorio;
  }

  colunasTabela: ({titulo: string; campo: string; pipe?: undefined} | {titulo: string; campo: string; pipe: string})[];
  enderecoForm!: FormGroup;
  config!: PaginationInstance;

  // mostrarFormulario: boolean = true;
  mostrarBtnAdicionar: boolean = true;
  ehAlteracaoBeneficiario: boolean = false;
  showErrorMessage: boolean = false;
  formTouched: boolean = false;
  isFormSubmited: boolean = false;
  isMoradiaInternacional: boolean = false;
  isOutroEstado: boolean = false;

  enderecoList: any[] = [];
  showInputEstadoOutros: any;
  listaEstados: any;
  listaPaises: any;
  listaCidades: any;
  enderecoListaCompleta: any[] = [];

  editingIndex: number = -1;
  podeCadastrarEditar: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    private _cepFormService: CepFormService,
    private _geo: GeoLocalizacaoService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private router: Router,
  ) {
    this.resetConfigPaginacao();
  }

  ngOnInit(): void {
    this.listasAux();
    this.criarForm();
    this.adicionarObrigatoriedadeNoFormulario();
    this.adcionarColunasTabela();
    this.monitorarMudancaCEP();
    this.regraCadastroEnderecoBeneficiario();
    this.cdr.detectChanges();
  }

  get ehSomenteLeitura(): boolean {
    return this._ehSomenteLeitura;
  }

  aplicarEstadoSomenteLeitura() {
    if (this.enderecoForm) {
      if (this.ehSomenteLeitura) {
        if (this.tabelaComponent) {
          this.tabelaComponent.mostrarBtnVisualizar = true;
        }
        this.podeCadastrarEditar = false;
        this.enderecoForm.disable();
      } else {
        this.enderecoForm.enable();
        if (this.tabelaComponent) {
          this.tabelaComponent.mostrarBtnVisualizar = false;
        }
        this.podeCadastrarEditar = true;
      }
    }
  }

  adcionarColunasTabela() {
    this.colunasTabela = [
      {
        titulo: 'CEP',
        campo: 'adressCep',
        pipe: 'cep',
      },
      {
        titulo: 'Endereço',
        campo: 'adress',
      },
      {
        titulo: 'Número',
        campo: 'adressNumber',
      },
    ];
  }

  criarForm() {
    this.enderecoForm = this.formBuilder.group({
      id: new FormControl(null),
      stateId: new FormControl(null, [Validators.maxLength(200), Validators.required]),
      cityId: new FormControl(null, [Validators.maxLength(200), Validators.required]),
      adressCep: new FormControl(null, Validators.required),
      adress: new FormControl(null, [Validators.maxLength(200), Validators.required]),
      adressNumber: new FormControl(null, [Validators.maxLength(30)]),
      adressNeighborhood: new FormControl(null, [Validators.maxLength(50), Validators.required]),
      adressComplement: new FormControl(null),
      cityName: new FormControl(null),
      stateName: new FormControl(null),
      internationalCity: new FormControl(null),
      internationalState: new FormControl(null),
      internationalHome: new FormControl(false, []),
      active: new FormControl(null),
      adressType: new FormControl(null),
    });
  }

  changeEstado(event: any) {
    // Limpa os campos de cidade e CEP
    this._cepFormService.limparCidadeECEP(this.enderecoForm);

    if (event) {
      this.listaCidadePorEstado(event);
    } else {
      this.listaCidades = [];
    }
  }

  listasAux() {
    this.buscarListaEstados();
    this.buscarlistaPaises();
  }

  buscarlistaPaises() {
    this._geo.ListCountries().subscribe(data => {
      this.listaPaises = data;
    });
  }

  listaCidadePorEstado(id: any[]) {
    if (id) {
      let state = [];
      state.push(id);
      this._geo.ListCitiesByStates(state).subscribe(data => {
        this.listaCidades = data && data;
      });
    }
  }

  buscarListaEstados() {
    this._geo.ListStates().subscribe(data => {
      this.listaEstados = data;
      // Encontrar o índice do elemento "Outro"
      const indexOutro = this.listaEstados.findIndex((item: {name: string}) => item.name === 'Outro');

      // Remover o elemento "Outro" da lista, se encontrado
      if (indexOutro > -1) {
        const outro = this.listaEstados.splice(indexOutro, 1)[0];
        // Adicionar o elemento "Outro" de volta no final da lista
        this.listaEstados.push(outro);
      }
    });
  }

  onChangeMoradiaInternacional($event: any) {
    if ($event.target.value == 'SIM') {
      this.isMoradiaInternacional = true;
      this.adicionarObrigatoriedadeNoFormulario();
    } else {
      this.isMoradiaInternacional = false;
      this.adicionarObrigatoriedadeNoFormulario();
    }
  }

  addEndereco() {
    this.formTouched = true;
    this.showErrorMessage = false;

    if (!this.isFormValid()) {
      this.showErrorMessage = true;
      this.toastr.warning('Verifique os campos obrigatórios.');
      this.toastr.toastrConfig.preventDuplicates = true;
      return;
    }

    if (this.enderecoForm.valid) {
      this.showErrorMessage = false;
      this.formTouched = false;
      this.isFormSubmited = false;

      if (this.editingIndex > -1) {
        this.enderecoList[this.editingIndex] = this.enderecoForm.value;
        this.editingIndex = -1;
      } else {
        this.enderecoForm.patchValue({internationalHome: this.isMoradiaInternacional});
        this.enderecoList.push(this.enderecoForm.value);
      }
      this.reset();
      this.enderecoForm.patchValue({internationalHome: false});
      this.regraCadastroEnderecoBeneficiario();
    }
  }

  reset() {
    this.enderecoForm.reset();
    this.showErrorMessage = false;
    this.formTouched = false;
    this.isFormSubmited = false;
    if (this.ehAlteracaoBeneficiario) this.mostrarFormulario = false;

    this.enderecoForm.patchValue({internationalHome: false});
    //this.onChangeMoradiaInternacional("NÃO");
    this.isMoradiaInternacional = false;
  }

  editarEnderecoItem(index: number) {
    this.mostrarBtnAdicionar = true;
    this.enderecoForm.reset();
    this.editingIndex = index;
    this.enderecoList[index];
    this.mostrarFormulario = true;

    this.changeEstado(this.enderecoList[index].stateId);
    this.enderecoForm.controls['internationalHome'].patchValue(this.enderecoList[index].internationalHome);

    if (this.enderecoList[index].internationalHome == true) {
      this.isMoradiaInternacional = true;
      this.adicionarObrigatoriedadeNoFormulario();
      this.enderecoForm.patchValue(this.enderecoList[index]);
    } else {
      this.isMoradiaInternacional = false;
      this.adicionarObrigatoriedadeNoFormulario();
      this.enderecoForm.patchValue(this.enderecoList[index]);
    }
  }

  visualizarEnderecoItem(index: number) {
    this.mostrarBtnAdicionar = true;
    this.enderecoForm.reset();
    this.editingIndex = index;
    this.enderecoList[index];
    this.mostrarFormulario = true;

    this.changeEstado(this.enderecoList[index].stateId);
    this.enderecoForm.controls['internationalHome'].patchValue(this.enderecoList[index].internationalHome);

    if (this.enderecoList[index].internationalHome == true) {
      this.isMoradiaInternacional = true;
      this.enderecoForm.patchValue(this.enderecoList[index]);
    } else {
      this.isMoradiaInternacional = false;
      this.enderecoForm.patchValue(this.enderecoList[index]);
    }
  }

  removerEndereco(index: number) {
    this.enderecoList.splice(index, 1);
    this.regraCadastroEnderecoBeneficiario();
  }

  isFormValid() {
    this.isFormSubmited = true;
    return this.enderecoForm.valid;
  }

  buscarCEP() {
    this._cepFormService.buscarCEP(this.enderecoForm);
  }

  onFieldChange() {
    // Chamado sempre que um campo de entrada é alterado
    if (this.formTouched) {
      this.showErrorMessage = !this.isFormValid();
    }
  }

  adicionarObrigatoriedadeNoFormulario() {
    if (!this.isMoradiaInternacional) {
      this.enderecoForm.get('internationalState')?.clearValidators();
      this.enderecoForm.get('internationalCity')?.clearValidators();
      this.enderecoForm.get('stateId')?.setValidators([Validators.required]);
      this.enderecoForm.get('cityId')?.setValidators([Validators.required]);
    } else {
      this.enderecoForm.get('internationalState')?.setValidators([Validators.required, Validators.maxLength(250)]);
      this.enderecoForm.get('internationalCity')?.setValidators([Validators.required, Validators.maxLength(250)]);
      this.enderecoForm.get('stateId')?.clearValidators();
      this.enderecoForm.get('cityId')?.clearValidators();
    }

    // --- Lógica Dinâmica do campo adressNumber ---
    const adressNumberControl = this.enderecoForm.get('adressNumber');
    if (this.numeroObrigatorio) {
      adressNumberControl?.setValidators([Validators.maxLength(30), Validators.required]);
    } else {
      adressNumberControl?.setValidators([Validators.maxLength(30)]);
    }
    adressNumberControl?.updateValueAndValidity();

    // --- Lógica Dinâmica do campo adressType ---
    const adressTypeControl = this.enderecoForm.get('adressType');
    if (this.numeroObrigatorio && this.mostrarTipoEndereco) {
      adressTypeControl?.setValidators([Validators.required]);
    } else {
      adressTypeControl?.setValidators([Validators.nullValidator]);
    }
    adressTypeControl?.updateValueAndValidity();

    // Atualize o estado dos controles para refletir as mudanças
    this.enderecoForm.get('internationalState')?.updateValueAndValidity();
    this.enderecoForm.get('internationalCity')?.updateValueAndValidity();
    this.enderecoForm.get('stateId')?.updateValueAndValidity();
    this.enderecoForm.get('cityId')?.updateValueAndValidity();
  }

  limparCamposEndereco() {
    this._cepFormService.limparCEP(this.enderecoForm);
  }

  heCrm(): boolean {
    return this.router.url.includes('/crm');
  }

  ehTelaBeneficiario() {
    this.tabelaComponent.mostrarColunaStatus = true;
    this.mostrarFormulario = true;
    this.mostrarBtnAdicionar = this.heCrm() ? true : false;
    this.tabelaComponent.mostraBtnEditar = false;
    this.tabelaComponent.mostrarBtnInativar = false;
    this.tabelaComponent.mostrarPaginacao = true;
  }

  ehAcaoBtnTabela(dados: any) {
    let dadosBtnAcao = dados;

    if (dadosBtnAcao.acao == tipoAcaoEnum.EDICAO) {
      this.editarEnderecoItem(dadosBtnAcao.index);
    } else if (dadosBtnAcao.acao == tipoAcaoEnum.EXCLUIR) {
      this.removerEndereco(dadosBtnAcao.index);
    } else if (dadosBtnAcao.acao == tipoAcaoEnum.VISUALIZAR) {
      this.visualizarEnderecoItem(dadosBtnAcao.index);
    } else if (dadosBtnAcao.acao == tipoAcaoEnum.PAGINACAO) {
      this.onTablePageChange(dadosBtnAcao.pagina);
    }
  }

  monitorarMudancaCEP() {
    this.enderecoForm.get('adressCep')?.valueChanges.subscribe(valor => {
      const cepApenasNumeros = valor?.replace(/\D/g, '');

      // Se o CEP atingir os 8 dígitos (completo), dispara a busca automaticamente
      if (cepApenasNumeros && cepApenasNumeros.length === 8) {
        this.buscarCEP();
      }
    });
  }

  resetConfigPaginacao() {
    this.config = {
      id: 'endereco',
      currentPage: 1,
      itemsPerPage: 5,
      totalItems: 0,
    };
  }

  atualizarListaPaginada() {
    this.config.totalItems = this.enderecoListaCompleta.length;

    const inicio = (this.config.currentPage - 1) * this.config.itemsPerPage;
    const fim = inicio + this.config.itemsPerPage;

    // Corta o array para exibir apenas os 5 registros correspondentes à página atual
    this.enderecoList = this.enderecoListaCompleta.slice(inicio, fim);
  }

  onTablePageChange(event: any) {
    this.config.currentPage = event;
    this.atualizarListaPaginada();
  }

  ehBeneficiario(): boolean {
    return this.router.url.includes('/beneficiario');
  }

  regraCadastroEnderecoBeneficiario() {
    if (this.ehBeneficiario() && this.enderecoList.length > 0) {
      this.mostrarBtnAdicionar = false;
    } else {
      this.mostrarBtnAdicionar = true;
    }
  }

  preencherFormComponenteSemTabela(dados: any) {
    const idEstado = dados.stateId || dados.city.stateId;
    this.enderecoForm.reset();
    this.enderecoForm.controls['stateId'].patchValue(idEstado);
    this.listaCidadePorEstado(idEstado);
    this.enderecoForm.patchValue(dados);
  }
}
